import { Moment } from 'moment';
import { ContentControlledReportableEvent } from '../reportable-event/content-controlled-reportable-event';
import { ContentControlledEditingDirective } from '../editing-directive/content-controlled-editing-directive';
import { ContentControlledEventActionEnum } from '../enums/content-controlled-event-action.enum';
import { MergedCensorshipEvent } from './merged-censorship-event';

export class CensorshipReportEntry {
  constructor(
    public mediaId: number,
    public tenantMediaUniqueId: string,
    public timestamp: Moment,
    public reportableEvents: ContentControlledReportableEvent[],
    public mediaFps: number,
    public editingDirectives: ContentControlledEditingDirective[],
  ) {}
  public get mergedEvents(): MergedCensorshipEvent[] {
    const mergedMap = new Map<number, Partial<MergedCensorshipEvent>>();

    for (const rep of this.reportableEvents) {
      mergedMap.set(
        rep.id,
        new MergedCensorshipEvent(
          rep.startsAtMs,
          rep.endsAtMs,
          rep.eventType,
          '',
          false,
          false,
        ),
      );
    }

    for (const editingDirective of this.editingDirectives) {
      const existing = mergedMap.get(editingDirective.id);
      if (existing) {
        existing.startsAtMs = editingDirective.startsAtMs;
        existing.endsAtMs = editingDirective.endsAtMs;
        existing.actionTitle =
          ContentControlledEventActionEnum[editingDirective.action];
        existing.isApproved = editingDirective.isApproved;
        existing.isMitigated = editingDirective.isMitigated;
      } else {
        mergedMap.set(
          editingDirective.id,
          new MergedCensorshipEvent(
            editingDirective.startsAtMs,
            editingDirective.endsAtMs,
            '',
            ContentControlledEventActionEnum[editingDirective.action],
            editingDirective.isApproved,
            editingDirective.isMitigated,
          ),
        );
      }
    }

    return Array.from(mergedMap.values()).map(
      (entry) =>
        new MergedCensorshipEvent(
          entry.startsAtMs ?? 0,
          entry.endsAtMs ?? 0,
          entry.eventType ?? '',
          entry.actionTitle ?? '',
          entry.isApproved ?? false,
          entry.isMitigated ?? false,
        ),
    );
  }
}
